var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "mb-3", attrs: { row: "", id: _vm.date } },
    [
      _c(
        "v-container",
        {
          staticClass: "pa-0 ma-0",
          staticStyle: { width: "100%", "max-width": "100%" },
          attrs: { "fill-height": "" }
        },
        [
          _vm.isClose
            ? [
                _c("v-flex", {
                  staticClass: "primary",
                  staticStyle: { height: "2px" },
                  attrs: { xs5: "", "full-width": "" }
                }),
                _vm._v(" "),
                _c("v-flex", {
                  staticClass: "mx-5 primary--text",
                  staticStyle: { "font-weight": "900", "text-align": "center" },
                  attrs: { xs2: "" },
                  domProps: { textContent: _vm._s(_vm.label) }
                }),
                _vm._v(" "),
                _c("v-flex", {
                  staticClass: "primary",
                  staticStyle: { height: "2px" },
                  attrs: { xs5: "", "full-width": "" }
                })
              ]
            : [
                _c("div", {
                  staticClass: "secondary",
                  staticStyle: { height: "2px", width: "32px" }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "px-2 primary--text",
                  staticStyle: { "font-weight": "900" },
                  attrs: { id: "seperator-text" },
                  domProps: { textContent: _vm._s(_vm.date) }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "secondary",
                  staticStyle: { height: "2px", width: "calc(100vw - 200px)" }
                })
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87bbf7ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87bbf7ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-chat-message-item-seperator/template.html
// module id = null
// module chunks = 